<script setup lang="ts">
const carousels = [
  {
    title: 'Buat Paket Reguler',
    description:
      'Masukkan data pengiriman paketmu, bisa banyak sekaligus, atau satu per satu. Tentukan metode pembayaran (COD atau Non-COD) dan pilih juga opsi penjemputan (Pick Up atau Drop Off).'
  },
  {
    title: 'Pilih Pengiriman Reguler',
    description:
      'Pilih layanan pengiriman reguler dari berbagai ekspedisi di KiriminAja, sesuaikan dengan ongkir dan estimasi waktu yang kamu butuhkan.'
  },
  {
    title: 'Berikan ke Kurir',
    description:
      'Tempelkan resi ke paket, lalu sesuai opsi penjemputan yang kamu pilih, tunggu kurir menjemput atau antar ke agen terdekat.'
  }
]
</script>

<template>
  <div class="bg-surface-container-low py-7 lg:py-16 relative overflow-hidden">
    <UiBgSkewY />
    <UiContainer class="flex flex-col gap-11 relative z-10">
      <UiSectionTitle
        class="text-center"
        title="Cara Kirim Paket Reguler, <br />Praktis dan Bisa Disesuaikan dengan Perangkatmu"
        title-as="h2"
        description="Kamu bisa kirim paket reguler melalui aplikasi atau dashboard
  KiriminAja dengan beberapa langkah mudah."
      />
      <UiCarouselFeature :items="carousels" />
    </UiContainer>
  </div>
</template>
